'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRhumb = require('react-rhumb');

var _UIAlert = require('UIComponents/alert/UIAlert');

var _UIAlert2 = _interopRequireDefault(_UIAlert);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FailedLoadBanner = function FailedLoadBanner(_ref) {
  var hasFailed = _ref.hasFailed;

  if (hasFailed) {
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(_reactRhumb.NavMarker, { name: 'FAILED_LOAD_BANNER' }),
      _react2.default.createElement(
        _UIAlert2.default,
        {
          titleText: _react2.default.createElement(_FormattedMessage2.default, { message: 'failedLoadBanner.title' }),
          type: 'danger',
          className: 'm-bottom-4'
        },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'failedLoadBanner.description' })
      )
    );
  }

  return null;
};

FailedLoadBanner.propTypes = {
  hasFailed: _react.PropTypes.bool
};

FailedLoadBanner.defaultProps = {
  hasFailed: false
};

exports.default = FailedLoadBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/loading/FailedLoadBanner.js
// module id = 176
// module chunks = 3 4